import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Seo from "@/components/Seo";
import Hero from "@/components/landing/Hero";
import Marquee from "@/components/landing/Marquee";
import About from "@/components/landing/About";
import Services from "@/components/landing/Services";
import WhyChoose from "@/components/landing/WhyChoose";
import Portfolio from "@/components/landing/Portfolio";
import B2B from "@/components/landing/B2B";
import Testimonials from "@/components/landing/Testimonials";
import Contact from "@/components/landing/Contact";

export default function Home() {
  const location = useLocation();

  useEffect(() => {
    const target = location.state?.scrollTo;
    if (target) {
      const t = setTimeout(() => {
        const el = document.querySelector(`#${target}`);
        if (el && window.__lenis) window.__lenis.scrollTo(el, { offset: -80 });
        else if (el) el.scrollIntoView({ behavior: "smooth" });
        window.history.replaceState({}, document.title);
      }, 300);
      return () => clearTimeout(t);
    }
  }, [location.state]);

  return (
    <>
      <Seo
        title="Almeida's Home Services | Remodeling in Charlotte, Pineville & Matthews"
        description="Family-owned remodeling serving Charlotte, Pineville, Matthews, Fort Mill & Rock Hill. Kitchens, baths, roofing, siding & flooring. Free estimates."
        path="/"
      />
      <Hero />
      <Marquee />
      <About />
      <Services />
      <WhyChoose />
      <Portfolio />
      <B2B variant="teaser" />
      <Testimonials />
      <Contact />
    </>
  );
}
